import PremiumPlayerInitializer from 'shared/initializers/premium_player_initializer';
import EmailConfirmationModal from 'shared/components/email_confirmation_modal';
import LatestCommentsWatchPage from 'components/desktop/LatestCommentsWatchPage/latest_comments_watch_page';
import PhoneVerificationModal from 'shared/components/phone_verification_modal';
import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';
import RequireLoginModal from 'desktop/components/require_login_modal';
import LocalStorageAdapter from 'shared/localstorage_adapter.js';
import CommentButton from 'desktop/components/comment_button';
import FollowStatus from 'shared/components/follow_status';
import { IsPremiumUser, ActiveLanguage, DanaProfile } from 'shared/vidio_helpers';
import KmklabsUtil from 'shared/kmklabs_util';
import BrowserHelper from 'shared/utilities/browser_helper';
import Topic from 'shared/topic';
import AhoyEvent from 'shared/ahoy_event';
import Discussion from 'shared/components/discussion';
import PinMessage from 'shared/components/pin_message';
import LoginOfferingHelper from 'shared/components/login_offering_helper';
import UserSegment from 'components/shared/UserSegment/UserSegment';
import GuideModal from 'components/desktop/GuideModal/GuideModal';
import ProfileCompletingAgeGenderModal from 'shared/components/profile/profile_completing_age_gender_modal';
import KidsToggle from 'components/desktop/KidsToggle/KidsToggle';
import HeaderMenuReact from 'components/desktop/HeaderMenu/HeaderMenu';
import BannerAd from 'components/shared/BannerAd/BannerAd';
import 'bootstrap/js/tooltip';

window.KLYUserDataExchange = require('components/shared/KLYUserDataExchange/KLYUserDataExchange').default;

// react
import React from "react";
import ReactDOM from "react-dom";

const Cookies = require('js-cookie');
const Tmpl = require('blueimp-tmpl');

const commentTemplate = require('templates/desktop/button/comment.jst.jade')
const followTemplate = require('templates/desktop/button/follow.jst.jade')

import { Interaction, DEFAULT_PATH } from "commons/Interaction/Interaction";

export default class InteractionStatus {
  static init() {
    let url = InteractionStatus.getInteractionUrl();

    Interaction
      .requestStatus(url)
      .then(InteractionStatus.handleResponse.bind(this));
  }

  static handleResponse(data){
    if (!window.isUserSignedIn) {
      this.clearContinueWatchData();
      this.clearRecentLivestreamingData();
    }

    if(data.current_user && data.current_user.officer){
      this.getShowAuthor();
    }
    this.setCsrfToken(data);

    this.setGeoblockCheck(data.capabilities);

    this.setEngagementButtons(data);

    const headerMenuContainerList = document.getElementsByClassName('js-header-menu-container')
    if (headerMenuContainerList.length != 0) {
      const headerMenuContainer = headerMenuContainerList[0]
      if(! headerMenuContainer.classList.contains("is-loaded")) {
        this.setHeaderMenu(data, headerMenuContainer);
      }
    }

    this.setUnverifiedEmailPrompt(data);
    this.bindVerifyButton();
    this.initLatestCommentWatchPage();
    this.setMeta(data.current_user);
    this.getShowStream(data.current_user);
    this.setSubscribeButton(data.current_user);
    this.setPremierCallToActionBanner();
    this.setUserGenderSegment({
        user_gender: data.current_user.user_gender,
        classification: data.current_user.classification
    });
    this.setVisitorGender(data.current_visitor);
    this.setVisitorDevice(data.current_visitor);
    this.showAgeGenderModal(data.current_user);
    this.verifyEmail();
    new ComponentInitializers();

    this.initializeChatComponent(data.capabilities);
    this.setMuxConfigs(data.capabilities);
    this.initLoginOffering(window.isUserSignedIn);
    this.setSegmentState(data.current_user);
    this.initGuideModal(window.isUserSignedIn);
    ComponentInitializers.initJsSectionComponent();
    BannerAd.setup();
  }

  static getInteractionUrl(){
    const defaultPath = DEFAULT_PATH;
    const livestreamingId = this.extractLivestreamingId();

    const temp = {};

    if(livestreamingId !== null){
      temp['livestreaming_id'] = livestreamingId;
      let params = new URLSearchParams(temp).toString();

      return [defaultPath, params].join("?");
    } else {
      return defaultPath;
    }
  }

  static extractLivestreamingId(){
    const regex = /live\/(\d+)/i;
    const pathName = BrowserHelper.pathName();
    const match = pathName.match(regex);
    const livestreamingId = (match && match[1]);

    return livestreamingId;
  }

  static clearContinueWatchData() {
    LocalStorageAdapter.removeItem('continue_watching');
  }

  static clearRecentLivestreamingData() {
    LocalStorageAdapter.removeItem('recent_livestreamings');
  }

  static setSegmentState(current_user) {
    let userSegment = new UserSegment(current_user);

    userSegment.setSegmentState();
  }

  static initLatestCommentWatchPage(){
    var latestComment = new LatestCommentsWatchPage();
    latestComment.init();
  }

  static getShowAuthor(){
    var element = document.getElementsByClassName('js-author-button__container')[0];
    if (element){
      var videoId = element.getAttribute('data-video-id');
      $.ajax({
        url: "/interactions_author.json?video_id=" + videoId,
        dataType: "json",
        method: "GET"
      }).done(function(data) {
        this.setAuthorButtons(data);
        new ComponentInitializers();
      }.bind(this));
    }
  }

  static getDanaProfile(){
    var element = $("a.option__dana-button");
    var danaBalance = $(".option__dana-balance");
    if (element) {
      element.attr("href", '#');
      DanaProfile.get(function(data) {
        danaBalance.html('<p class="option__dana-saldo">Saldo DANA</p>' + data.balance);
        element.attr("href", data.mini_dana);
      });
    }
  }

  static getShowStream(currentUser){
    let initializer = InteractionStatus.setupPremiumPlayerInitializer(currentUser);
    initializer.initialize();
  }

  static setupPremiumPlayerInitializer(currentUser){
    return (new PremiumPlayerInitializer(currentUser));
  }

  static setSubscribeButton(current_user){
    if(!this.isEmpty(current_user)){
      var element = document.querySelector('.js-component.b-premium-subscribe-banner__button.button.button--red');
      if(element){
        var lang = ActiveLanguage.get();
        var buttonText = window.Locale[lang].premium.subscribe;
        var newSubscribe = document.createElement('a');
        newSubscribe.setAttribute('href','/packages');
        newSubscribe.className = 'b-premium-subscribe-banner__button button button--red';
        newSubscribe.innerHTML= buttonText;
        element.parentNode.replaceChild(newSubscribe,element);
      }
    }
  }

  static setAuthorButtons(data){
    try{
      if(data.show){
        var template = $(Tmpl("tmpl-video-author", data));
        var element = $(".js-author-button__container");
        element.html(template);
      }
    }catch(err){ return; }
  }

  static setEngagementButtons(data){
    if((document.getElementsByClassName('js-engagement-comment')).length > 0){
      this.setCommentButton(data);
    }
    if((document.getElementsByClassName('add-to-collection-container')).length > 0){
      this.setAddToCollectionButton(data);
    }
    if((document.getElementsByClassName('report-abuse-container')).length > 0){
      this.setReportAbuseButton(data);
    }
    if((document.getElementsByClassName('follow-button')).length > 0){
      this.setFollowButton(data);
    }

    new FollowStatus();

    $('[data-toggle="tooltip"]').tooltip();
  }

  static setCommentButton(data) {
    var lang = ActiveLanguage.get();

    var votableId = KmklabsUtil.videoId();
    var html = $(commentTemplate({user: data.current_user, votable:{id: votableId, type: "Video", path: window.location.href}, locale: window.Locale[lang].watch}));
    $('.js-engagement-comment').html(html);

    var commentButton = $('.video-engagement__comment-button-trigger[data-component="CommentButton"]');
    if(commentButton) {
      commentButton = new CommentButton({$element: commentButton});
      commentButton.init();
    }

    var requireLoginModalButton = $('.video-engagement__comment-button-trigger[data-component="RequireLoginModal"]');
    if(requireLoginModalButton) {
      requireLoginModalButton = new RequireLoginModal({element: requireLoginModalButton});
      requireLoginModalButton.init();
    }
  }

  static setFollowButton(data){
    var lang = ActiveLanguage.get();

    if($('a.button-follow.js-component').length == 0){
      return;
    }
    var followData = $('a.button-follow.js-component').data();

    followData.isLoggedIn = Object.keys(data.current_user).length > 0;
    var html = $(followTemplate({
      data: followData,
      locale: window.Locale[lang].watch
    }));
    $('.follow-button').html(html);
  }

  static setAddToCollectionButton(data){
    var lang = ActiveLanguage.get();
    data.lang = lang == 'id' ? 'Tambahkan Ke' : 'Add to';
    try {
      var template = $(Tmpl("tmpl-add-to-collection", data));
      var element = $(".add-to-collection-container");
      element.html(template);
    } catch(err) { return; }
  }

  static setReportAbuseButton(data){
    var lang = ActiveLanguage.get();
    data.lang = lang == 'id' ? 'Laporkan' : 'Report';
    try {
      var template = $(Tmpl("tmpl-report-abuse", data));
      var element = $(".report-abuse-container");
      element.html(template);
    } catch(err) { return; }
  }

  static setCsrfToken(data) {
    if(data.current_user.token !== undefined) {
      $('meta[name="csrf-token"]').attr("content", data.current_user.token);
    }
  }

  static setHeaderMenu(data, headerMenuContainer) {
    const lang = ActiveLanguage.get();
    ReactDOM.render(
      React.createElement(HeaderMenuReact, {
        user: data.current_user,
        locale: window.Locale[lang].header,
        dana: {
          bind: data.current_user.dana_bind
        }
      }),
      headerMenuContainer
    );
    
    headerMenuContainer.classList.add('is-loaded');

    if(data.current_user.username) {
      this.setCoachmark(window.location.href);
    }

    const subscribeButton = document.querySelector("a.header-login__subscribe")
    if(subscribeButton) {
      subscribeButton.onclick = this.sendHeaderLoginSubscribeButtonEvent
    }

    const kidsToggleButton = document.querySelector('.option__kids-mode-toggle-button');
    if(kidsToggleButton) {
      let kidsToggle = new KidsToggle({element: kidsToggleButton});
      kidsToggle.init();
    }

    if (window.isUserSignedIn) {
      const element = document.querySelector(".header-login__user-info");
      if (!element) return;

      element.onmouseenter = function(){
        if(data.current_user.dana_bind) {
          this.getDanaProfile();
        }

        this.sendHeaderMenuShownEvent();
      }.bind(this);
    }
  }

  static sendHeaderMenuShownEvent() {
    AhoyEvent.send(
      "VIDIO::SUBSCRIPTION",
      {action: 'impression', feature: 'voucher promotion'}
    )
  }

  static sendHeaderLoginSubscribeButtonEvent() {
    AhoyEvent.send(
      "VIDIO::SUBSCRIPTION",
      {action: 'subscribe', feature: 'subscribe button'}
    )
  }

  static setCoachmark(path) {
    var coachmarkCookie = document.cookie.split("coach_mark_following_menu=")[1];
    if(coachmarkCookie) {
      coachmarkCookie = coachmarkCookie.split(";")[0];
    }

    if(coachmarkCookie != "true" && path.match(/dashboard\/feeds/) === null ){
      var headerCoachmark = $('.site-header__right-coachmark');
      if(headerCoachmark.length) {
        headerCoachmark.removeClass('hide-me');
      }
    }
  }

  static setUnverifiedEmailPrompt(data) {
    if(data.current_user.username && !data.current_user.account_confirmed) {
      var alertWarningUserConfirmation = $(".notification--warning-user-confirmation");

      if(alertWarningUserConfirmation.length > 0 && !$('body').hasClass('onboardings')) {
        alertWarningUserConfirmation.removeClass("hide-me");
        alertWarningUserConfirmation.closest(".notification").removeClass("hide-me");
        $("#vidio-modal__email").text(data.current_user.email);
      }
    }
  }

  static bindVerifyButton() {
    var verifyButton = $(".notification--warning-user-confirmation__button");

    verifyButton.on("click", function(event) {
      event.preventDefault();
      Cookies.remove('unverified_user_modal');
      InteractionStatus.showPhoneVerificationPopUp();
    });
  }

  static setMeta(user){
    $('meta[name="current-username"]').attr('content',user.username);
    $('meta[name="current-user-id"]').attr('content',user.user_id);

    if(window.kmklabs){
      if(!window.kmklabs.gtm.user_name){
        window.kmklabs.gtm.user_name = user.username;
      }

      if(!window.kmklabs.gtm.user_id){
        window.kmklabs.gtm.user_id = user.user_id;
      }

      if(!window.kmklabs.gtm.login_status){
        window.kmklabs.gtm.login_status = window.isUserSignedIn;
      }

      if(!window.kmklabs.gtm.user_full_name){
        window.kmklabs.gtm.user_full_name = user.full_name;
      }

      if(!window.kmklabs.gtm.user_birthdate){
        window.kmklabs.gtm.user_birthdate = user.birthdate;
      }

      if(!window.kmklabs.gtm.ue){
        window.kmklabs.gtm.ue = window.KLYUserDataExchange.encrypt(user.email);
      }

      if(!window.kmklabs.gtm.pn){
        window.kmklabs.gtm.pn = window.KLYUserDataExchange.encrypt(user.phone);
      }

      if(window.kmklabs && window.kmklabs.ads){
        window.kmklabs.ads.age = user.age || '';
        window.kmklabs.ads.active_sub = (user.has_active_subscription == true).toString();
        window.kmklabs.ads.device_brand = user.device_brand || '';
        window.kmklabs.ads.device_model = user.device_model || '';
        window.kmklabs.ads.sub_package = user.sub_package || '';
      }
    }
  }

  static setPremierCallToActionBanner() {
    var callToActionBanner = document.querySelector('.js-premier-call-to-action-banner');

    if(callToActionBanner) {
      if(IsPremiumUser.get()) {
        callToActionBanner.classList.add('hide');
      } else {
        callToActionBanner.classList.remove('hide');
      }
    }
  }

  static setUserGenderSegment(options) {
    if(window.kmklabs && window.kmklabs.gtm) {
      window.kmklabs.gtm.classification = options.classification;
      window.kmklabs.gtm.user_gender = options.user_gender;
    }
  }

  static setVisitorGender(visitor = {}) {
    if (window.isUserSignedIn) return;

    if (window.kmklabs && window.kmklabs.gtm) {
      window.kmklabs.gtm.user_gender = visitor.gender;
    }
  }

  static setVisitorDevice(visitor = {}) {
    if (window.isUserSignedIn) return;

    if(window.kmklabs && window.kmklabs.ads){
      window.kmklabs.ads.device_brand = visitor.device_brand || '';
      window.kmklabs.ads.device_model = visitor.device_model || '';
    }
  }

  static showPhoneVerificationPopUp() {
    if (!InteractionStatus.phoneVerificationModal) {
      InteractionStatus.phoneVerificationModal = new PhoneVerificationModal();
      InteractionStatus.phoneVerificationModal.init();
    }
    InteractionStatus.phoneVerificationModal.openModal();
  }

  static showAgeGenderModal(currentUser) {
    if(!window.isUserSignedIn) return;

    if(InteractionStatus.shouldShowAgeGenderPopUp(currentUser)) {
      InteractionStatus.showAgeGenderPopUp(currentUser);
      Cookies.remove('show_age_gender_modal');
    }
  }

  static showAgeGenderPopUp(currentUser) {
    if (!InteractionStatus.ageGenderModal) {
      InteractionStatus.ageGenderModal = new ProfileCompletingAgeGenderModal(currentUser);
      InteractionStatus.ageGenderModal.init();
    }
    InteractionStatus.ageGenderModal.show();
  }

  static shouldShowAgeGenderPopUp(currentUser) {
    return !(currentUser.age && currentUser.user_gender_confirmed) &&
      (Cookies.get('show_age_gender_modal') === 'true');
  }

  static isEmpty(obj) {
    for(var prop in obj) {
      if(Object.prototype.hasOwnProperty.call(obj, prop))
        return false;
    }
    return true;
  }

  static verifyEmail() {
    if (!window.isUserSignedIn) return;

    let verifyButton = $('#email_verify_button');

    let emailConfirmationModal = new EmailConfirmationModal();
    emailConfirmationModal.init();

    verifyButton.on('click', event => {
      event.preventDefault();
      let currentEmail = $('#user_email').val();

      $.ajax({
        method: 'POST',
        beforeSend: xhr => {
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        url: '/dashboard/setting/email',
        data: { 'user[email]': currentEmail },
        dataType: 'json'
      })
      .done(() => {
        emailConfirmationModal.showElement(emailConfirmationModal.$modal);
        emailConfirmationModal.showEmailConfirmationSection(currentEmail);
      })
      .fail(xhr => {
        window.alert(xhr.responseJSON.error_message);
      });
    });
  }

  static initializeChatComponent({ can_chat, can_remove_chat }) {
    const chatEnableDOM = document.querySelector('.livestreaming-discussion-enable')
    const chatDisableDOM = document.querySelector('.livestreaming-discussion-disable')

    if (can_chat) {
      chatDisableDOM.classList.add('hide')
      chatEnableDOM.classList.remove('hide')

      const discussion = new Discussion()
      const pinMessage = new PinMessage()

      discussion.init({
        canRemoveChat: can_remove_chat
      });
      pinMessage.init();
    }
  }

  static setMuxConfigs({ mux_reporting }) {
    window.mux_configs = {
      enabled: mux_reporting
    };
    Topic.publish('mux_configured');
  }

  static initLoginOffering(isLogin) {
    if(!isLogin) {
      LoginOfferingHelper.showLoginOffer();
    }
  }

  static initGuideModal(isLogin) {
    if (!isLogin) return;

    const guideModalDOM = document.querySelector('.js-guide-modal');

    if (guideModalDOM) {
      const guideModal = new GuideModal({ element: guideModalDOM });
      guideModal.init();
    }
  }

  static setGeoblockCheck({ can_bypass_geoblock }) { 
    if (!can_bypass_geoblock && this.publishGeoblockCheckWhenPlayerIsReady() !== true){
      let checkGeoblockReadyInterval = setInterval(() => {
        if(this.publishGeoblockCheckWhenPlayerIsReady()) {
          clearInterval(checkGeoblockReadyInterval);
        }
      }, 100);
    }
  }

  static publishGeoblockCheckWhenPlayerIsReady() {
    if(window.player !== undefined && window.player.isReady()){
      Topic.publish('check_geoblock');
      return true;
    } 
  }
}
